import classNames from "classnames";
import { FORM_ERROR } from "final-form";
import { observer } from "mobx-react-lite";
import React, { useContext, useState } from "react";
import { Form as FinalForm, Field } from "react-final-form";
import { useTranslation } from "react-i18next";

// reactstrap components
import { Alert, Button, Form, FormGroup } from "reactstrap";
import { combineValidators, isRequired, matchesField } from "revalidate";
import { translationHookOptions } from "../../app/localization/localization";
import { ChangePwdFormValues } from "../../app/models/user";
import { RootStoreContext } from "../../app/stores/rootStore";
import TextInput from "../common/TextInput";
import { error } from "console";

const validate = combineValidators({
  oldPassword: isRequired("oldPassword"),
  newPassword: isRequired("newPassword"),
  confirmNewPwd: matchesField(
    "newPassword",
    ""
  )({
    message: "Passwords do not match",
  }),
});

const UpdatePasswordForm = () => {
  const rootStore = useContext(RootStoreContext);
  const { changePwd } = rootStore.userStore;
  const { theme } = rootStore.commonStore;
  const [initialValues, setInitialValues] = useState(new ChangePwdFormValues());
  const [t] = useTranslation(
    ["features", "translation","errors"],
    
    translationHookOptions
  );

  return (
    <>
      <FinalForm
        validate={validate}
        initialValues={initialValues}
        onSubmit={(values) =>
          changePwd(values)
            .then(() => {
              setInitialValues(values);
              setInitialValues(new ChangePwdFormValues());
            })
            .catch((error) => ({
              [FORM_ERROR]: error,
            }))
        }
        render={({
          handleSubmit,
          submitting,
          submitError,
          invalid,
          pristine,
          values,
          dirtySinceLastSubmit,
          touched,
        }) => (
          <Form onSubmit={handleSubmit} role="form">
            <div className="pl-lg-2">
              <FormGroup className="mb-5">
                <label className="form-control-label" htmlFor="oldPassword">
                  {t("update_pwd_modal_current_label")}
                </label>
                <Field
                  id="oldPassword"
                  name="oldPassword"
                  component={TextInput}
                  type="password"
                  className="form-control-alternative w-100"
                  autoComplete="off"
                />
              </FormGroup>
              <FormGroup>
                <label className="form-control-label" htmlFor="newPassword">
                  {t("update_pwd_modal_new_label")}
                </label>
                <Field
                  id="newPassword"
                  name="newPassword"
                  component={TextInput}
                  type="password"
                  className={classNames(
                    "w-100",
                    touched &&
                      touched.confirmNewPwd &&
                      invalid &&
                      !dirtySinceLastSubmit && (values.confirmNewPwd !== values.newPassword)
                      ? "is-invalid"
                      : "form-control-alternative w-100"
                  )}
                  autoComplete="off"
                />
              </FormGroup>
              <FormGroup>
                <label className="form-control-label" htmlFor="confirmNewPwd">
                  {t("update_pwd_modal_confirm_label")}
                </label>
                <Field
                  id="confirmNewPwd"
                  name="confirmNewPwd"
                  component={TextInput}
                  type="password"
                  className={classNames(
                    "w-100",
                    touched &&
                      touched.confirmNewPwd &&
                      invalid &&
                      !dirtySinceLastSubmit && (values.confirmNewPwd !== values.newPassword)
                      ? "is-invalid"
                      : "form-control-alternative w-100"
                  )}
                  autoComplete="off"
                />
                {values.confirmNewPwd !== values.newPassword && (<>
                  <div className="invalid-feedback">
                  {t("update_pwd_modal_mismatch")}
                </div>
                </>)}
              
              </FormGroup>
              {submitError && !dirtySinceLastSubmit && (
                <Alert color="danger" className="w-100">
                {submitError.data  && submitError.data.errors ? (
                 Array.isArray(submitError.data.errors) ? (
                    <ul style={{ textAlign: "left" , paddingLeft:"3%"}}>
                    {submitError.data.errors
                      .map((error: any) => error.errorCode)
                      .map((errorCode: any, index: any) => (
                        <li key={index} style={{marginTop:"3%"}}>
                          {" "}
                          {t(errorCode, { ns: "errors" })}
                        </li>
                      ))}
                  </ul>
                  ) : (
                    <ul style={{ textAlign: "left" ,paddingLeft:"3%"}}>
                    {Object.values<string>(submitError.data.errors)
                      .flat()
                      .map((err: any, i: any) => {
                        if(err=="errorOldPsw")
                     return <li key={i} style={{marginTop:"3%"}}> {t(err, { ns: "errors" })}</li>;
                         }
                      )}
                  </ul>
                  )
                ) : null}
               </Alert>
              )}
              <Button
                disabled={(invalid && !dirtySinceLastSubmit) || pristine}
                className={classNames(
                  "genericButton my-4",
                  `${theme!.buttonColor} ${theme!.buttonBorderColor} ${
                    theme!.buttonTextColor
                  }`
                )}
                type="submit"
              >
                {t("confirm", { ns: "translation" })}
              </Button>
            </div>
          </Form>
        )}
      />
    </>
  );
};

export default observer(UpdatePasswordForm);
